// components/AppBar.styled.ts
import MuiAppBar from "@mui/material/AppBar";
import MuiToolbar from "@mui/material/Toolbar";
import styled from "styled-components";

import { device } from "utils/sizes";
import { colourScheme } from "utils/styling/colours";

export const StyledAppBar = styled(MuiAppBar)`
    background-color: ${colourScheme.primaryDark};
    border: 1px solid ${colourScheme.primaryLight};
    color: ${colourScheme.white};
    border-radius: 0.5rem;
    padding: 0.5rem 1rem;
    width: 100%;
    max-width: 90vw;

    ${device.sm} {
        padding: 0.75rem 1.5rem;
    }

    ${device.md} {
        padding: 1rem 2rem;
    }
`;

export const StyledToolbar = styled(MuiToolbar)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0;
`;

export const ButtonGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem; /* Space between buttons */

    /* Optional: Adjust spacing, margins, or alignment if needed */
    justify-content: flex-end; /* Align buttons to the right */
`;

export const Button = styled.button`
    background: none;
    border: none;
    color: ${colourScheme.white};
    cursor: pointer;
    font-size: 0rem;
    margin-right: 1rem;
    display: flex;
    align-items: center;

    &:hover {
        color: ${colourScheme.primaryLight};
    }

    &:last-child {
        margin-right: 0;
    }

    svg {
        margin-right: 0.5rem;
    }

    ${device.md} {
        font-size: 1rem;
        svg {
            margin-right: 0;
        }
    }
`;
